"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
function IPTDisclaimer(props) {
    return (React.createElement("div", { className: props.cssClass }, "Please note, all figures include Insurance Premium Tax"));
}
exports.default = IPTDisclaimer;
;
//# sourceMappingURL=IPTDisclamer.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/components/IPTDisclamer.js
// module id = 366
// module chunks = 0